import { createClient } from "@supabase/supabase-js";

import type { Database } from "@/types/database";

function resolveSupabaseEnv(): { url: string; key: string } {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

  if (url && key) {
    return { url, key };
  }

  // Vitest / Bun test: Vite env가 비어 있을 수 있음(특히 `bun test`는 Vitest setup을 타지 않음).
  const isTest = import.meta.env.MODE === "test" || (typeof process !== "undefined" && process.env.NODE_ENV === "test");

  if (isTest) {
    return {
      url: url || "http://127.0.0.1:54321",
      key: key || "test-publishable-key",
    };
  }

  throw new Error("VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY are required.");
}

const { url, key } = resolveSupabaseEnv();

export const supabase = createClient<Database>(url, key);
